/**
 * Domyślna konfiguracja sceny synth
 */
export const defaultConfig = {
    sun: {
        size: 80,
        positionX: 0,
        positionY: 0.3,
        color: 0xff00ff
    },
    mountains: {
        enabled: true,
        solid: true, // Nieprzezroczysty fill - góry nie prześwitują przez siebie (occlusion)
        fillColor: 0x000000, // Kolor wypełnienia gór (0x000000 = niewidoczny na czarnym tle)
        height: 40, // Maks. wysokość gór
        stripWidth: 80, // Szerokość każdego boku (od krawędzi drogi na zewnątrz)
        rows: 30, // Liczba rzędów siatki (wzdłuż Z)
        cols: 12, // Liczba kolumn na bok (wzdłuż X)
        noiseScale: 0.04, // Skala noise dla wysokości
        distortion: 0.5 // (zachowane dla kompatybilności)
    },
    ground: {
        distortion: 0.2,
        gridSize: 50,
        speed: 0.5,
        linesCount: 10,
        lineWidth: 0.1,
        glowIntensity: 0.9,
        verticalRandomness: 0.5,
        blockNewSegments: false,
        bloom: {
            enabled: true,
            threshold: 0.05,
            strength: 0.2,
            radius: 0.4
        },
        lineBreaks: {
            horizontal: false,
            vertical: false,
            position: 'random',
            strength: 1.0,
            count: 2,
            skipVerticalForBreaks: false
        },
        useAltRoadRenderer: false // true = prostsza wersja (EdgesGeometry), false = stara wersja (TubeGeometry)
    },
    camera: {
        speed: 0.2,
        fov: 75
    },
    render: {
        pixelRatio: null,
        resolutionScale: 1.0
    }
};

